import { Content } from 'antd/lib/layout/layout';
import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useDispatch, useSelector } from 'react-redux';
import { useMetadataMutation } from 'src/redux/api/auth';
import { getAuth, metadataCompleted } from 'src/redux/slices/auth';
import ErrorScreen from 'src/screens/error';
import ErrorModal from 'src/screens/error/modals/ErrorModal';
import useError, { reportError } from 'src/screens/error/useError';
import { LogoutModal, useLogoutModal } from 'src/screens/shared/components/LogoutModal';
import useResponsive from 'src/utils/hooks/useResponsive';

import Header from './Header/Header';
import { StyledLayout } from './Styles';

type Props = {
  user: User;
  children: any;
};

const Index = ({ children }: Props) => {
  const auth = useSelector(getAuth);
  const dispatch = useDispatch();
  const {
    openModalLogout,
    showModalLogout,
    handleOkModalLogout,
    handleCancelModalLogout,
    fetching,
    modalTitle: logoutTitle,
  } = useLogoutModal({ superAdminFullLogout: auth.superAdminUser && !auth.currentUser });
  const { isMobileOrTablet } = useResponsive();
  const [metadata] = useMetadataMutation();
  const { setError } = useError();

  const onLogout = () => {
    showModalLogout();
  };

  // Fetch metadata when component mounts or when account changes
  useEffect(() => {
    if (auth.currentAccount?.id) {
      metadata(auth.currentAccount.id)
        .unwrap()
        .then((response) => {
          dispatch(metadataCompleted(response.data));
        })
        .catch((e) => setError(reportError(e)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.currentAccount?.id]);

  return (
    <StyledLayout className={isMobileOrTablet ? 'mobile-style' : ''}>
      <ErrorBoundary fallbackRender={({ error }) => <ErrorScreen error={error} />}>
        <Header onLogout={onLogout} />
        <Content className="content-app-layout">{children}</Content>
      </ErrorBoundary>

      <ErrorModal />
      {openModalLogout && (
        <LogoutModal
          onOk={handleOkModalLogout}
          onCancel={handleCancelModalLogout}
          fetching={fetching}
          title={logoutTitle}
        />
      )}
    </StyledLayout>
  );
};

export default Index;
